<template>
  <v-row justify="center" v-if="plan_inscripcion">
    <v-dialog v-model="dialog" scrollable width="500px" :fullscreen="$vuetify.breakpoint.mobile">
      <v-card tile>
        <v-toolbar dark color="orange" dense flat class="max-height">
          <v-spacer></v-spacer>
          <v-toolbar-title class="white--text"> Aprobar el plan de cobro del programa</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="py-2">
          <p class="text-center black--text h4">{{ programa.nombre_compuesto }}</p>
          <v-data-table class="elevation-5 py-2" :headers="headers" :items="plan_inscripcion.cobros" hide-default-footer disable-pagination>
            <template v-slot:top>
              <p class="h4 text-center text-primary">{{ `Nombre: ${plan_inscripcion.nombre}`.toUpperCase() }}</p>
            </template>
          </v-data-table>
          <v-card-subtitle primary-title class="mb-0 pb-0">
            <p>Revisar que los conceptos y montos sean los correctos para este plan</p>
            <p class="mb-0 pb-0 red--text font-weight-bold">
              NOTA:: esta ventana solo aparece una sola vez por programa, usted sera el responsable de aprobarlo
            </p>
            <br />
            <p v-if="existRecibo" class="text-center red--text h4">Estudiante ya tiene recibos emitidos, solo queda aprobar</p>
          </v-card-subtitle>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn v-if="!existRecibo" color="info" rounded small @click="$emit('generatePlan', true)">
            <v-icon class="mr-1">mdi-sync</v-icon> Cambiar de plan
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" v-if="programa" @click="aprobarPlan" rounded small> <v-icon class="mr-1"> mdi-content-save</v-icon> Aprobar Plan </v-btn>
          <v-btn color="blue darken-1" outlined rounded small @click="closeDialog"> Cancelar <v-icon> mdi-close</v-icon> </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import xaxios from '@/xaxios';
export default {
  props: ['programa', 'existRecibo'],
  data() {
    return {
      dialog: false,
      api_rest: process.env.VUE_APP_API_REST,
      plan_inscripcion: null,
      headers: [
        { text: 'Nombre', value: 'nombre' },
        { text: 'Monto', value: 'monto' },
        { text: 'Cuotas', value: 'cuotas' },
      ],
    };
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
  },
  methods: {
    showThisView(plan_inscripcion) {
      this.dialog = true;
      this.plan_inscripcion = plan_inscripcion;
    },
    aprobarPlan() {
      const url = `${this.api_rest}/api/esam/programa/plan/aprobar`;
      let data = {
        programa_id: this.programa.programa_id,
        plan_cobro_id: this.plan_inscripcion.plan_cobro_programa_id,
        user_id: this.$store.state.DATA_USER.id,
      };
      xaxios
        .post(url, data)
        .then(() => {
          this.$emit('clickedAprobePlan', true);
          this.closeDialog();
        })
        .catch(({ response: { data } }) => this.$root.$notify.show(`${data.error}`, { color: 'danger' }));
    },
    closeDialog() {
      this.dialog = false;
      this.plan_inscripcion = null;
    },
  },
};
</script>
